import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const CrisisBanner = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const emergencyContacts = [
    {
      title: "Emergency Services",
      number: "999",
      description: "For immediate life-threatening emergencies. Police, ambulance, fire service.",
      icon: "🚑"
    },
    {
      title: "Samaritans",
      number: "116 123",
      description: "24/7 free confidential support for anyone in emotional distress. No judgment, just listening.",
      icon: "☎️"
    },
    {
      title: "Crisis Text Line",
      number: "Text SHOUT to 85258",
      description: "24/7 text support service. Free on all major mobile networks.",
      icon: "💬"
    },
    {
      title: "NHS 111",
      number: "111",
      description: "24/7 NHS helpline for urgent but non-emergency medical concerns.",
      icon: "🏥"
    },
    {
      title: "Mind Mental Health",
      number: "0300 123 3393",
      description: "Info and support. Mon-Fri 9am-6pm (except bank holidays).",
      icon: "🌐"
    }
  ];

  return (
    <>
      {/* Crisis Banner */}
      <div className="py-3 px-4 mt-0">
        <div className="max-w-7xl mx-auto text-center flex justify-center items-center">
          <button
            onClick={() => setIsOpen(true)}
            className="group flex items-center justify-center gap-2 hover:scale-[1.01] transition-all duration-300 text-sm md:text-lg font-bold leading-tight text-red-600"
          >
            <span className="animate-pulse text-xl">⚠️</span>
            <span className="group-hover:underline decoration-2 underline-offset-4">
              {t("crisisBannerText") === "crisisBannerText" || !t("crisisBannerText") 
                ? "If you need immediate contact ongoing to crisis, contact to emergency services! Click here for help!" 
                : t("crisisBannerText")}
            </span>
            <span className="animate-pulse text-xl">⚠️</span>
          </button>
        </div>
      </div>

      {/* Crisis Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            {/* Content */}
            <div className="p-6">
              {/* Simple Table */}
              <div className="overflow-x-auto mb-6">
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-800">Service</th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-800">Contact</th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-800">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {emergencyContacts.map((contact, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="border border-gray-300 px-4 py-3">
                          <div className="flex items-center">
                            <span className="mr-2">{contact.icon}</span>
                            <span className="font-medium">{contact.title}</span>
                          </div>
                        </td>
                        <td className="border border-gray-300 px-4 py-3">
                          <span className="font-bold text-red-600">{contact.number}</span>
                        </td>
                        <td className="border border-gray-300 px-4 py-3 text-sm text-gray-700">
                          {contact.description}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Close Button */}
              <div className="text-center">
                <button
                  onClick={() => setIsOpen(false)}
                  className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CrisisBanner;
